import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { RiUserSettingsLine, RiAdminLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { CommonActions, useCommonSelector } from '@wajeez-web/stores/common';
// import getFirstRoute from "../../util/GetFirstRoute";
// import Button from "../../components/General/Button";

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

const roleNavigation = [
  {
    name: 'Super Admin',
    value: 'super-admin',
    href: '/',
    icon: (
      <RiAdminLine
        className="me-3 h-6 w-6 text-gray-500 group-hover:text-gray-700"
        aria-hidden="true"
      />
    ),
  },
  {
    name: 'Admin',
    value: 'base',
    href: '/',
    icon: (
      <RiUserSettingsLine
        className="me-3 h-6 w-6 text-gray-500 group-hover:text-gray-700"
        aria-hidden="true"
      />
    ),
  },
];

const RoleViewMenu = () => {
  const dispatch = useAppDispatch();
  const { theme } = useCommonSelector((state) => state.common.settings);
  const navigate = useNavigate();

  // const getIcon = () => {
  //   switch (theme) {
  //     case 'base':
  //       return RiUserSettingsLine;
  //     case 'super-admin':
  //       return RiAdminLine;
  //   }
  // };

  // const onSelect = (val: string) => {
  //   dispatch(CommonActions.setTheme(val));
  //   if (val === 'super-admin') {
  //     navigate('/content-entities');
  //   }// else navigate(getFirstRoute());
  // };
  return <div></div>;
  // return (
  //   <Button
  //     color="textPrimary"
  //     shape="circle"
  //     bg="primary"
  //     Icon={getIcon()}
  //     type="text"
  //     onClick={() => onSelect(theme === 'super-admin' ? 'base' : 'super-admin')}
  //   />
  //   // <Menu as="div" className="relative z-50">
  //   //   {({ open }) => (
  //   //     <>
  //   //       <div>
  //   //         <Menu.Button sdx c 3oC className="  flex items-center text-sm rounded-full focus:outline-none ">
  //   //           <span className="sr-only">Open user menu</span>
  //   //           <div className="pl-3">{getIcon()}</div>
  //   //         </Menu.Button>
  //   //       </div>
  //   //       <Transition
  //   //         show={open || false}
  //   //         as={Fragment}
  //   //         key={1 + "view"}
  //   //         enter="transition ease-out duration-100"
  //   //         enterFrom="transform opacity-0 scale-95"
  //   //         enterTo="transform opacity-100 scale-100"
  //   //         leave="transition ease-in duration-75"
  //   //         leaveFrom="transform opacity-100 scale-100"
  //   //         leaveTo="transform opacity-0 scale-95"
  //   //       >
  //   //         <Menu.Items
  //   //           static
  //   //           className={`origin-top-left absolute ltr:right-0 rtl:left-0  mt-2 w-52 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none`}
  //   //         >
  //   //           <div className="py-2">
  //   //             {roleNavigation.map((item) => {
  //   //               return (
  //   //                 <Menu.Item key={item.name}>
  //   //                   {({ active }) => (
  //   //                     <div
  //   //                       onClick={() => {
  //   //                         onSelect(item.value);
  //   //                       }}
  //   //                       className={classNames(
  //   //                         active ? "bg-gray-100" : "",
  //   //                         "group flex items-center px-4 py-2 text-sm text-gray-700"
  //   //                       )}
  //   //                     >
  //   //                       {item.icon}
  //   //                       {item.name}
  //   //                     </div>
  //   //                   )}
  //   //                 </Menu.Item>
  //   //               );
  //   //             })}
  //   //           </div>
  //   //         </Menu.Items>
  //   //       </Transition>
  //   //     </>
  //   //   )}
  //   // </Menu>
  // );
};

export default RoleViewMenu;
